import { FieldWrapper } from "@progress/kendo-react-form";
import { CusFormLabel } from "../validation/Form-Components";

const StatusEnquiryDtls = (props) => {
    const {data} =props;
 
    return(
        <FieldWrapper>
             <CusFormLabel
                leftLabelId={'lblAppNum'} leftLabelName={'Application Number'}
                id={'appNum'} name={data.ApplicationNo} />

            <CusFormLabel
                leftLabelId={'lblUen'} leftLabelName={'UEN'}
                id={'uen'} name={data.UEN} />

            <CusFormLabel
                leftLabelId={'lblFacility'} leftLabelName={'Facility'}
                id={'facility'} name={data.Facility} />

            <CusFormLabel
                leftLabelId={'lblFinanceType'} leftLabelName={'Financing Type'}
                id={'financeType'} name={data.FinancingType} />

            <CusFormLabel
                leftLabelId={'lblAmount'} leftLabelName={'Amount'}
                id={'amount'} name={data.Amount?data.Amount !==null?'SGD '+ parseFloat(data.Amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):'':''} />

            <CusFormLabel
                leftLabelId={'lblTenure'} leftLabelName={'Tenure'}
                id={'tenure'} name={data.Tenure+' years'} />

            <CusFormLabel
                leftLabelId={'lblDate'} leftLabelName={'Application Date'}
                id={'date'} name={data.AppDate} />

        </FieldWrapper>
    )
}

export default StatusEnquiryDtls;